export default __webpack_public_path__ + "static/media/received_282363499053625.2d9269b4.jpg";